import React, { Ref, useEffect } from 'react';
import { Canvas, Image } from 'fabric/fabric-impl';

import { EditorStore, useStore } from '../../store/createStore';
import { CanvasHandler } from '../../handlers/CanvasHandler';

function CreationArea(props: { canvas: Canvas }, ref: Ref<any>) {
  const activeTextEditingMobile = useStore<EditorStore, any>('activeTextEditingMobile')[0];
  const prevSelectedTool = useStore<EditorStore, string>('prevSelectedTool')[0];
  const canvasHandler = new CanvasHandler(props.canvas);
  const creationAreaWithMenuClasses = !prevSelectedTool
    ? 'canvas-container__without-gallery'
    : 'canvas-container__with-gallery';
  const className = activeTextEditingMobile
    ? 'canvas-container__full'
    : creationAreaWithMenuClasses;

  useEffect(() => {
    if (!props.canvas) {
      return;
    }

    // El tiempo en milisengundos del timeout debe ser el mismo tiempo configurado en el campo transición
    // de la clase css canvas-container configurada en index.css. Esto se da así para que la configuración de resize se
    // aplique justo después de que la animación haya terminado. Si no se da así, el área del canvas no queda adecuadamente
    // dimensionada, luego termina provocando que el área de trabajo se corte y se vea incompleta en algún punto.
    setTimeout(() => {
      const workArea = props.canvas.backgroundImage as Image;
      canvasHandler.resize(
        { height: workArea.height as number, width: workArea.width as number },
        false
      );
    }, 200);
  }, [props.canvas, prevSelectedTool]);

  return (
    <div className={`${className}`} style={{ display: 'unset' }}>
      <canvas ref={ref} className={``} />
    </div>
  );
}

export default React.forwardRef(CreationArea);
